import {typeOf} from '@zjy/zjy-ui/lib/utils/dom'
import { sizeConver, formatDay, integer } from '@/assets/utils'

/**
 * Show plural label if time is plural number
 * @param {number} time
 * @param {string} label
 * @return {string}
 */
function pluralize (time, label) {
  if (time === 1) {
    return time + label
  }
  return time + label + 's'
}

/**
 * @param {number} time
 */
export function timeAgo (time) {
  const between = Date.now() / 1000 - Number(time)
  if (between < 3600) {
    return pluralize(~~(between / 60), ' minute')
  } else if (between < 86400) {
    return pluralize(~~(between / 3600), ' hour')
  } else {
    return pluralize(~~(between / 86400), ' day')
  }
}

/**
 * Number formatting
 * like 10000 => 10k
 * @param {number} num
 * @param {number} digits
 */
export function numberFormatter (num, digits) {
  const si = [
    { value: 1E18, symbol: 'E' },
    { value: 1E15, symbol: 'P' },
    { value: 1E12, symbol: 'T' },
    { value: 1E9, symbol: 'G' },
    { value: 1E6, symbol: 'M' },
    { value: 1E3, symbol: 'k' }
  ]
  for (let i = 0; i < si.length; i++) {
    if (num >= si[i].value) {
      return (num / si[i].value + 0.1).toFixed(digits).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + si[i].symbol
    }
  }
  return num.toString()
}

/**
 * 10000 => "10,000"
 * @param {number} num
 */
export function toThousandFilter (num) {
  return (+num || 0).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
}

// 格式化 文件大小
export function formatSizeFilter (limit) {
  return sizeConver(limit)
}


// 格式化日期
export function formatDayFilter (date) {
  if (typeOf(date) === 'Date') {
    return formatDay(date)
  } else if (typeOf(date) === 'Number' || integer(date)){
    return formatDay(new Date(+date))
  } else {
    return date
  }
}

// 获取最后一级目录
export function lastLevelDirectory (path) {
  if (typeof path === 'string') {
    const paths = path.split('/')
    return `/${paths[paths.length - (paths.length > 1 ? 2 : 1)] || '全部文件'}`
  } else {
    return path
  }
}

// 格式计量/计价 文件
export function formatFileTypeFilter (fileType) {
  let type = fileType
  switch (+fileType) {
    case 1:
      type = '计价'
      break
    case 2:
      type = '计量'
      break
    case 3:
      type = '计量协同'
      break
    default:
  }
  return type
}


